import { defineComponent as _defineComponent } from 'vue'

import { mdiLink } from "@mdi/js";
import { Ref, computed, defineComponent, ref } from "@nuxtjs/composition-api";

import { useFeatureDetection, useTranslate } from "@/composables";

const __default__ = defineComponent({});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'CopyButton',
  props: {
  absolute: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: "grey-10",
  },
  value: {
    type: String,
    required: true,
  },
},
  emits: ["copy"],
  setup(__props, { emit: emits }: { emit: ({
  (e: "copy"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const hiddenInput: Ref<HTMLTextAreaElement | undefined> = ref();
const button: Ref<Vue | null> = ref(null);
/**
 * It is necessary to handle showing/hiding the tooltip manually/programmatically rather than utilizing
 * the built-in props/hooks. When using the activator slot, with a click handler, and having disabled
 * both hover and focus triggers, the `input` event was firing twice from the tooltip, causing the
 * tooltip text element to hide immediately. Additionally this was only happening if the button wasn't
 * already focused, so a second click would yield the desired result. This was also happening regardless
 * of having additional click handlers on the button, or the `href` prop converting it to a link element.
 */
const tooltipOpen = ref(false);

const { t } = useTranslate();
const featureDetection = useFeatureDetection();

const labelText = t("copy link to clipboard");

const icon = computed(() => mdiLink);

const onCopy = () => {
  emits("copy");
  if (featureDetection.clipboard) {
    // 92% global support: https://caniuse.com/mdn-api_clipboard_writetext
    navigator.clipboard.writeText(props.value);
  } else {
    // Fallback for Clipboard API. Anyone else can just copy from the address bar
    hiddenInput.value?.select();
    document.execCommand("copy");
    (button?.value?.$el as HTMLElement).focus();
  }

  // Show tooltip after copying since focus will change in the fallback method of copying
  tooltipOpen.value = true;

  return props.value;
};

return { __sfc: true,props, emits, hiddenInput, button, tooltipOpen, t, featureDetection, labelText, icon, onCopy }
}

})